import { Pipe, PipeTransform } from '@angular/core';
import { MemberType } from '../../customerservice/common/constants';
import { BeneluxCountries } from '../../customerservice/enums/countries.enums';


@Pipe({ name: 'displayNameFormat' })
export class DisplayNameFormatPipe implements PipeTransform {
    constructor() {

    }
    transform(details: any, trigger?: boolean): string {

        let displayName = '';
        if (details) {
            if (details.firstName) {
                displayName += this.titleCaseValue(details.firstName) + " ";
            } if (details.middleName && details.displayMiddleName) {
                displayName += this.titleCaseValue(details.middleName) + " ";
            } if (details.lastName) {
                displayName += this.titleCaseValue(details.lastName);
            }
        }
        return displayName;
    }

    titleCaseValue(value: string): string {
        if (value) {
            let capitalizedInput = value.replace(/\w\S*/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase()));
            const parts = capitalizedInput.split('-');
            // Capitalize the first letter of each part after the hyphen
            const capitalizedParts = parts.map(part => part.charAt(0).toUpperCase() + part.slice(1));
            // Join the parts back together with hyphens
            capitalizedInput = capitalizedParts.join('-');
            return capitalizedInput;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/common/pipes/display-name-format.pipe.ts